export default __webpack_public_path__ + "static/media/marriage_and_cohabitation_agreement.206f93af.svg";